'use client';

import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslation } from '@/lib/i18n';

/** 弹窗覆盖层 + 容器，点击遮罩关闭（与 FeedbackDialog 同款 portal 模式） */
export function ModalOverlay({
  open,
  onClose,
  children,
  className,
}: {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  className?: string;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!open || !mounted) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-1500 flex items-center justify-center bg-black/50 px-4"
      onClick={onClose}
    >
      <section
        className={cn(
          'max-h-[92vh] overflow-y-auto rounded-[20px] bg-[#171717] text-white shadow-2xl',
          className,
        )}
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </section>
    </div>,
    document.body,
  );
}

export function ModalCloseButton({
  onClose,
  className,
}: {
  onClose?: () => void;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-label={t('Close')}
      onClick={onClose}
      className={cn(
        'flex size-5 items-center justify-center text-white transition-colors hover:text-[#B7B9BC]',
        className,
      )}
    >
      <X className="size-5" strokeWidth={1.67} />
    </button>
  );
}
